import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgListOutlined = ({ size, title = 'ListOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 7h15M4 12h15M4 17h8"
        />
    </svg>
);

export default withIcon(SvgListOutlined);
